import IconError from '@components/atoms/Icons/IconError'
import { Alert, AlertDescription, AlertTitle } from '@components/ui/Alert'
import { cn } from '@helper/utils/cn'
import { PropsWithChildren } from 'react'

interface ErrorMessageProps {
  dataTestId?: string
  title?: string
  icon?: React.ReactNode
  variant?: 'destructive' | 'default'
  className?: string
}

export function ErrorMessage({
  dataTestId,
  title,
  children,
  icon,
  variant = 'destructive',
  className,
}: PropsWithChildren<ErrorMessageProps>) {
  return (
    <Alert
      variant={variant}
      className={cn(
        className,
        'rounded-md my-4 text-error',
        // Alert defaults to [&>svg]:size-4; override so IconError dimensions apply
        '[&>svg]:!size-6 has-[>svg]:grid-cols-[auto_1fr]'
      )}
      data-testid={dataTestId ?? 'error-message'}
    >
      {icon ?? <IconError />}
      {title && <AlertTitle>{title}</AlertTitle>}
      <AlertDescription className="grid gap-1">
        {children}
      </AlertDescription>
    </Alert>
  )
}